import { c as _c } from "react/compiler-runtime";
import Img from '@/components/elements/Img';
import Link from '@/components/elements/Link';
import LimitedText from '@/components/modules/LimitedText';
import { LANGUAGES, LOCALE } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BBookableReceptionTypeEnum } from '@/types/backend';
import { ReceptionTypeTag } from '@winelidays/wld-tsx-2/elements';
import { Languages } from '@winelidays/wld-tsx-2/modules';
const EntityCardTitle = t0 => {
    const $ = _c(22);
    const { title, href, isReservation, mapPopup, light, information, languages, maxTitleRows } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== information || $[1] !== light || $[2] !== translate) {
        t1 = !light && (information === null || information === void 0 ? void 0 : information.receptionType) && (information === null || information === void 0 ? void 0 : information.receptionType) === BBookableReceptionTypeEnum.Private ? <ReceptionTypeTag receptionType={information.receptionType} translate={translate} linkComponent={Link}/> : null;
        $[0] = information;
        $[1] = light;
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const typeReceptionContent = t1;
    let t2;
    if ($[4] !== languages || $[5] !== light || $[6] !== translate) {
        t2 = !light && languages ? <Languages languages={languages} translate={translate} locale={LOCALE} langs={LANGUAGES} imgComponent={Img} className="mr-3 last:mr-0 align-baseline"/> : null;
        $[4] = languages;
        $[5] = light;
        $[6] = translate;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    const languagesContent = t2;
    const titleContainerClassName = `entity-title text-lg mb-1 ${isReservation ? "md:-mt-1" : ""}`;
    const linkClassName = `after:content-[' '] after:absolute after:inset-0 after:z-[1] ${mapPopup ? "leading-6 sm:leading-normal" : ""}`;
    let t3;
    if ($[8] !== maxTitleRows || $[9] !== title) {
        t3 = maxTitleRows ? <LimitedText text={title} maxRows={maxTitleRows} noSeeMoreButton={true}/> : title;
        $[8] = maxTitleRows;
        $[9] = title;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    const titleContent = t3;
    let t4;
    if ($[11] !== href || $[12] !== linkClassName || $[13] !== titleContent) {
        t4 = href ? <Link href={href} className={linkClassName}>{titleContent}</Link> : titleContent;
        $[11] = href;
        $[12] = linkClassName;
        $[13] = titleContent;
        $[14] = t4;
    }
    else {
        t4 = $[14];
    }
    const titleWithLink = t4;
    let t5;
    if ($[15] !== titleWithLink) {
        t5 = <h4 className="font-semibold inline align-baseline mr-3 last:mr-0">{titleWithLink}</h4>;
        $[15] = titleWithLink;
        $[16] = t5;
    }
    else {
        t5 = $[16];
    }
    let t6;
    if ($[17] !== languagesContent || $[18] !== t5 || $[19] !== titleContainerClassName || $[20] !== typeReceptionContent) {
        t6 = <div className={titleContainerClassName}>{t5}{languagesContent}{typeReceptionContent}</div>;
        $[17] = languagesContent;
        $[18] = t5;
        $[19] = titleContainerClassName;
        $[20] = typeReceptionContent;
        $[21] = t6;
    }
    else {
        t6 = $[21];
    }
    return t6;
};
export default EntityCardTitle;
